<template>
    <ToastComponent ref="toast" />
    <LoginComponent @show-toast="showToast" @user-set="handleUserSet" />
</template>

<script>
import LoginComponent from '../components/LoginComponent.vue';
import ToastComponent from '@/components/ToastComponent.vue';
import { useAuth } from '@/composables/useAuth';

export default {
    name: 'LoginView',
    components: {
        LoginComponent,
        ToastComponent
    },
    setup() {
        const { login } = useAuth();
        return { login };
    },
    methods: {
        async handleUserSet(email, name, permissions, profilePicture, subscription) {
            // Use the composable to handle login
            await this.login({
                email,
                name,
                permissions,
                profilePicture,
                subscription
            });
            
            // Redirect to main view after successful login
            this.$router.push('/');
        },
        showToast(message, type) {
            this.$refs.toast.showToast(message, type);
        }
    }
};
</script>

<style scoped>
/* No additional styles needed as the LoginComponent has its own styling */
</style>
